export * from './InquirySuccessCard'
